import logger from 'helpers/logger';
import { ErrorBoundary } from 'react-error-boundary';
import { capitalizeFirstLetter } from 'helpers/string';
import React from 'react';
import dynamic from 'next/dynamic';

export interface ModuleMapFeatureProps {
	contentModule: Umbraco.ContentModule;
	accessToken?: any;
	culture?: Umbraco.Cultures;
}

const modules = {
	HeroCardFeature: dynamic(() => import('features/Modules/HeroCard').then((mod) => ({ default: mod.HeroCardFeature }))),
	LinkFeature: dynamic(() => import('features/Modules/Link').then((mod) => ({ default: mod.LinkFeature }))),
	ContentSectionFeature: dynamic(() => import('features/Modules/ContentSection').then((mod) => ({ default: mod.ContentSectionFeature }))),
	ContentCardFeature: dynamic(() => import('features/Modules/ContentCard').then((mod) => ({ default: mod.ContentCardFeature }))),
	VideoCardFeature: dynamic(() => import('features/Modules/VideoCard').then((mod) => ({ default: mod.VideoCardFeature }))),
	NewsletterSignupFeature: dynamic(() => import('features/Modules/NewsletterSignup').then((mod) => ({ default: mod.NewsletterSignupFeature }))),
	PromotionFeature: dynamic(() => import('features/Modules/Promotion').then((mod) => ({ default: mod.PromotionFeature }))),
	MediaStoryFeature: dynamic(() => import('features/Modules/MediaStory').then((mod) => ({ default: mod.MediaStoryFeature }))),
	DashboardFeature: dynamic(() => import('features/Modules/Dashboard').then((mod) => ({ default: mod.DashboardFeature }))),
	CategoryListFeature: dynamic(() => import('features/Modules/CategoryList').then((mod) => ({ default: mod.CategoryListFeature }))),
	LoginFeature: dynamic(() => import('features/Modules/Login').then((mod) => ({ default: mod.LoginFeature }))),
	FeaturedProductsFeature: dynamic(() => import('features/Modules/FeaturedProducts').then((mod) => ({ default: mod.FeaturedProductsFeature }))),
	ContactFormPickerFeature: dynamic(() => import('features/Modules/ContactFormPicker').then((mod) => ({ default: mod.ContactFormPickerFeature }))),
	M1ArticleModuleFeature: dynamic(() => import('features/Modules/M1ArticleModule').then((mod) => ({ default: mod.M1ArticleModuleFeature }))),
	M5TextAndImageFeature: dynamic(() => import('features/Modules/M5TextAndImage').then((mod) => ({ default: mod.M5TextAndImageFeature }))),
	M38MultiCategoryLinksModuleFeature: dynamic(() =>
		import('features/Modules/M38MultiCategoryLinksModule').then((mod) => ({ default: mod.M38MultiCategoryLinksModuleFeature })),
	),
	M42HighlightRichtextFeature: dynamic(() =>
		import('features/Modules/M42HighlightRichtext').then((mod) => ({ default: mod.M42HighlightRichtextFeature })),
	),

	M30ProductFeaturesFeature: dynamic(() =>
		import('features/Modules/M30ProductFeatures').then((mod) => ({ default: mod.M30ProductFeaturesFeature })),
	),
	M31ProductGridFeature: dynamic(() => import('features/Modules/M31ProductGrid').then((mod) => ({ default: mod.M31ProductGridFeature }))),
	M32ProductTabsFeature: dynamic(() => import('features/Modules/M32ProductTabs').then((mod) => ({ default: mod.M32ProductTabsFeature }))),
	M37LibraryModuleFeature: dynamic(() => import('features/Modules/M37Library').then((mod) => ({ default: mod.M37LibraryModuleFeature }))),
	EquipmentPerformanceFeature: dynamic(() =>
		import('features/Modules/EquipmentTabs/EquipmentPerformanceFeature').then((mod) => ({ default: mod.EquipmentPerformanceFeature })),
	),
	SupportCenterFeature: dynamic(() => import('features/Modules/SupportCenter').then((mod) => ({ default: mod.SupportCenterFeature }))),
	PaymentPageFeature: dynamic(() => import('features/Modules/PaymentPageFeature').then((mod) => ({ default: mod.PaymentPageFeature }))),
	ProductFeature: dynamic(() => import('features/Modules/Product/ProductFeature').then((mod) => ({ default: mod.ProductFeature }))),
	SliderFeature: dynamic(() => import('features/Modules/Slider').then((mod) => ({ default: mod.SliderFeature }))),
	InformationPageFeature: dynamic(() => import('features/Modules/InformationPageFeature').then((mod) => ({ default: mod.InformationPageFeature }))),
	DeliveryPageFeature: dynamic(() => import('features/Modules/DeliveryPageFeature').then((mod) => ({ default: mod.DeliveryPageFeature }))),
	AccordionNavigationFeature: dynamic(() =>
		import('features/Modules/AccordionNavigation').then((mod) => ({ default: mod.AccordionNavigationFeature })),
	),
	AcademyPageFeature: dynamic(() => import('features/Modules/AcademyPage/AcademyPageFeature').then((mod) => ({ default: mod.AcademyPageFeature }))),
	ArticleHeaderFeature: dynamic(() => import('features/Modules/ArticleHeader').then((mod) => ({ default: mod.ArticleHeaderFeature }))),
	ArticleMediaFeature: dynamic(() => import('features/Modules/ArticleMedia').then((mod) => ({ default: mod.ArticleMediaFeature }))),
	ArticleTextFeature: dynamic(() => import('features/Modules/ArticleText').then((mod) => ({ default: mod.ArticleTextFeature }))),
	BasketPageFeature: dynamic(() => import('features/Modules/BasketPageFeature').then((mod) => ({ default: mod.BasketPageFeature }))),
	CategoryFilterFeature: dynamic(() => import('features/Modules/CategoryFilter').then((mod) => ({ default: mod.CategoryFilterFeature }))),
	ContactFormFeature: dynamic(() => import('features/Modules/ContactForm').then((mod) => ({ default: mod.ContactFormFeature }))),
	CookieInfoFeature: dynamic(() => import('features/Modules/CookieInfo').then((mod) => ({ default: mod.CookieInfoFeature }))),
	M28ProductOverviewFeature: dynamic(() =>
		import('features/Modules/M28ProductOverview').then((mod) => ({ default: mod.M28ProductOverviewFeature })),
	),
	M39AnchorMenuModuleFeature: dynamic(() => import('features/Modules/M39AnchorMenu').then((mod) => ({ default: mod.M39AnchorMenuModuleFeature }))),
	ModalSignupFormFeature: dynamic(() => import('features/Modules/ModalSignupForm').then((mod) => ({ default: mod.ModalSignupFormFeature }))),
	ModalHelpFormFeature: dynamic(() => import('features/Modules/ModalHelpForm').then((mod) => ({ default: mod.ModalHelpFormFeature }))),
	OrderDetailPageFeature: dynamic(() => import('features/Modules/OrderDetailPage').then((mod) => ({ default: mod.OrderDetailPageFeature }))),
	ProductSearchListFeature: dynamic(() => import('features/Modules/ProductSearchList').then((mod) => ({ default: mod.ProductSearchListFeature }))),
	ProductListFeature: dynamic(() => import('features/Modules/ProductList').then((mod) => ({ default: mod.ProductListFeature }))),
	ReceiptPageFeature: dynamic(() => import('features/Modules/ReceiptPageFeature').then((mod) => ({ default: mod.ReceiptPageFeature }))),
	EquipmentListFeature: dynamic(() =>
		import('features/Modules/EquipmentList/EquipmentListFeature').then((mod) => ({ default: mod.EquipmentListFeature })),
	),
	EmbeddedScriptFeature: dynamic(() => import('features/Modules/EmbeddedScript').then((mod) => ({ default: mod.EmbeddedScriptFeature }))),
};

export const ModuleMapFeature: React.FC<ModuleMapFeatureProps> = ({ contentModule, accessToken, culture }) => {
	const production = process.env.NODE_ENV === 'production';

	const { documentType } = contentModule;
	const visibility = contentModule.content.properties.visibility || null;

	const moduleName = `${capitalizeFirstLetter(documentType)}Feature`;

	const DynamicModule = modules[moduleName];

	const message = `Component [${documentType}] is missing a React Component. Add missing export '${moduleName}' from '/features`;

	if (!DynamicModule && !production) {
		return <div>{message}</div>;
	}

	if (!DynamicModule && production) {
		logger.error(message);
		return null;
	}

	const errorHandler = (error: Error, info: { componentStack: string }) => {
		logger.error(`Error with component [${documentType}]: ${error}. ${info.componentStack}`);
	};

	const hideTheComponent =
		visibility === 'hidden' || (visibility === 'authenticatedonly' && !accessToken) || (visibility === 'anonymousonly' && !!accessToken);
	return (
		<ErrorBoundary FallbackComponent={() => null} onError={errorHandler}>
			{!hideTheComponent && <DynamicModule {...contentModule} accessToken={accessToken} culture={culture} />}
		</ErrorBoundary>
	);
};
